export default __webpack_public_path__ + "static/splash-3-26d71d873f2743fc3534aa186b62b80c.png";